'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# DecisisSVG
An SVG Decisis icon
 */
var DecisisSVG = function DecisisSVG(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? undefined : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width;
  return _react2.default.createElement(
    'svg',
    {
      'aria-label': 'Decisis',
      role: 'img',
      height: height || undefined,
      width: width || undefined,
      viewBox: '0 0 85.000000 87.000000',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    _react2.default.createElement(
      'g',
      {
        id: 'decisis',
        fill: color,
        fillRule: 'nonzero',
        transform: 'translate(0.000000,87.000000) scale(0.100000,-0.100000)'
      },
      _react2.default.createElement('path', { d: 'M230 731 l-185 -88 -3 -72 c-2 -59 1 -79 18 -107 11 -20 20 -48 20 -65 0 -16 2 -29 5 -29 3 0 81 38 173 84 l167 84 165 -84 c91 -45 168 -83 173 -83 4 -1 7 14 7 32 0 17 9 43 20 57 15 20 20 41 20 100 l0 75 -185 93 c-102 50 -191 92 -198 92 -6 0 -95 -40 -197 -89z m351 -83 l139 -71 0 -44 0 -43 -148 74 -147 74 -135 -69 c-74 -37 -141 -68 -147 -68 -8 -1 -13 13 -13 37 l0 37 143 72 c78 40 148 72 156 72 7 1 76 -31 152 -71z' }),
      _react2.default.createElement('path', { d: 'M263 397 l-123 -62 0 -97 0 -98 40 -20 c21 -11 42 -20 45 -20 3 0 5 40 5 90 l0 90 40 20 40 20 0 -123 0 -123 45 -22 45 -22 0 215 c0 118 -3 215 -7 214 -5 0 -63 -28 -130 -62z' }),
      _react2.default.createElement('path', { d: 'M450 245 c0 -118 2 -215 5 -215 3 0 24 9 45 20 l40 20 0 125 c0 69 3 125 8 125 4 0 22 -9 40 -20 l32 -20 0 -90 c0 -49 2 -90 5 -90 3 0 24 9 45 20 l40 20 0 100 0 100 -120 60 c-66 33 -124 60 -130 60 -6 0 -10 -76 -10 -215z' })
    )
  );
};

DecisisSVG.propTypes = {
  /** a color for the icon */
  color: _propTypes2.default.string,
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string
};

DecisisSVG.displayName = 'DecisisSVG';

exports.default = DecisisSVG;
DecisisSVG.__docgenInfo = {
  'description': '# DecisisSVG\r\nAn SVG Decisis icon',
  'methods': [],
  'displayName': 'DecisisSVG',
  'props': {
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    },
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    }
  }
};